import { render, staticRenderFns } from "./BAsyncAutocompleteCommon.vue?vue&type=template&id=6a668730&"
import script from "./BAsyncAutocompleteCommon.vue?vue&type=script&lang=js&"
export * from "./BAsyncAutocompleteCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports